import { create } from 'zustand';
import { Language, TabId, User, UserRole, PermissionCheck } from './types';
import { getPermissions } from './permissions';

interface AppState {
  // Language
  lang: Language;
  setLang: (lang: Language) => void;
  toggleLang: () => void;

  // Active Tab
  activeTab: TabId;
  setActiveTab: (tab: TabId) => void;

  // Selected Projects (for radar comparison)
  selectedProjectIds: string[];
  setSelectedProjectIds: (ids: string[]) => void;
  toggleProjectId: (id: string) => void;

  // User and Permissions (for future authentication)
  user: User | null;
  userRole: UserRole | null;
  setUser: (user: User | null) => void;
  setUserRole: (role: UserRole | null) => void;
  getPermissions: () => PermissionCheck;
}

export const useAppStore = create<AppState>((set, get) => ({
  // Language
  lang: 'cn',
  setLang: (lang) => set({ lang }),
  toggleLang: () =>
    set((state) => ({ lang: state.lang === 'en' ? 'cn' : 'en' })),

  // Active Tab
  activeTab: 'home',
  setActiveTab: (tab) => set({ activeTab: tab }),

  // Selected Projects
  selectedProjectIds: [],
  setSelectedProjectIds: (ids) => set({ selectedProjectIds: ids }),
  toggleProjectId: (id) =>
    set((state) => ({
      selectedProjectIds: state.selectedProjectIds.includes(id)
        ? state.selectedProjectIds.filter((pid) => pid !== id)
        : [...state.selectedProjectIds, id],
    })),

  // User and Permissions
  user: null,
  userRole: null,
  setUser: (user) => set({ user, userRole: user?.role || null }),
  setUserRole: (role) => set({ userRole: role }),
  getPermissions: () => {
    const state = get();
    return getPermissions(state.userRole);
  },
}));

